import Router from '../Router';
import { FantasyController } from '../../controllers';

export default class FantasyRouter extends Router {
	initialize(options) {
		this.typeMenu = 'teams';
		this.controller = new FantasyController(options);
	}

	get appRoutes() {
		return {
			'fantasy(/team)': 'team',
			'fantasy/trades(/:player_id)': 'trades',
			'fantasy/team/rankings(/:squad_id)': 'rankings'
		};
	}
}